/* Hard Hoof: site-wide behaviour. Themes, header, command palette, sparks, reveal, goat eyes. */
function hhHighlight(value, words) {
  const source = String(value == null ? '' : value);
  const escape = s => s.replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const terms = [...new Set(words.filter(w => w.length > 1))].sort((a, b) => b.length - a.length);
  if (!terms.length) return escape(source);
  const pattern = new RegExp(terms.map(w => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'gi');
  let out = '', last = 0;
  for (const match of source.matchAll(pattern)) {
    out += escape(source.slice(last, match.index)) + '<mark>' + escape(match[0]) + '</mark>';
    last = match.index + match[0].length;
  }
  return out + escape(source.slice(last));
}
if (typeof module !== 'undefined' && module.exports) module.exports = { hhHighlight };
(function () {
  if (typeof document === 'undefined') return;
  const d = document, root = d.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;
  root.classList.add('js');
  const HH = window.HH = window.HH || {};
  HH.highlight = hhHighlight;
  HH.reduce = reduce;
  HH.store = {
    get(k, f) { try { const v = localStorage.getItem('hh.' + k); return v == null ? f : JSON.parse(v); } catch (e) { return f; } },
    set(k, v) { try { localStorage.setItem('hh.' + k, JSON.stringify(v)); } catch (e) { /* storage off */ } }
  };
  const index = (() => { try { return JSON.parse(d.getElementById('hh-index').textContent); } catch (e) { return { pages: [], actions: [], icons: {}, themes: [] }; } })();
  HH.index = index;
  HH.shots = window.HH_SHOTS || {};

  /* ---------- Themes: the same eight Hard Hoof OS wears ---------- */
  const themes = index.themes || [];
  const byId = Object.fromEntries(themes.map(t => [t.id, t]));
  HH.themes = themes;
  const meta = d.querySelector('meta[name="theme-color"]');
  function wear(id) {
    const t = byId[id] || themes[0];
    if (!t) return;
    root.dataset.theme = t.id; root.dataset.wall = t.w; root.dataset.flags = t.f;
    if (meta) meta.content = t.c;
    d.querySelectorAll('[data-theme-name]').forEach(el => { el.textContent = t.n; });
    d.querySelectorAll('[data-pick]').forEach(b => b.setAttribute(b.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-pressed', String(b.dataset.pick === t.id)));
    d.dispatchEvent(new CustomEvent('hh:theme', { detail: t }));
  }
  /* Switch, and let the new theme grow out of the point that asked for it. */
  HH.setTheme = (id, x, y) => {
    if (!byId[id]) return false;
    HH.store.set('theme', id);
    if (id === root.dataset.theme) return true;
    if (x == null) { x = innerWidth / 2; y = innerHeight / 2; }
    if (reduce || !d.startViewTransition) { wear(id); return true; }
    root.classList.add('is-theming');
    const vt = d.startViewTransition(() => wear(id));
    vt.ready.then(() => {
      const r = Math.hypot(Math.max(x, innerWidth - x), Math.max(y, innerHeight - y));
      root.animate({ clipPath: [`circle(0px at ${x}px ${y}px)`, `circle(${r}px at ${x}px ${y}px)`] },
        { duration: 620, easing: 'steps(14, end)', pseudoElement: '::view-transition-new(root)' });
    }).catch(() => {});
    const stall = setTimeout(() => vt.skipTransition(), 1500);   /* a background tab never finishes it */
    vt.finished.finally(() => { clearTimeout(stall); root.classList.remove('is-theming'); });
    return true;
  };
  HH.themeId = () => root.dataset.theme || 'horn';
  wear(HH.themeId());

  const centre = el => { const r = el.getBoundingClientRect(); return [r.left + r.width / 2, r.top + r.height / 2]; };
  d.addEventListener('click', e => {
    const b = e.target.closest('[data-pick]');
    if (!b) return;
    const [cx, cy] = e.clientX ? [e.clientX, e.clientY] : centre(b);
    HH.setTheme(b.dataset.pick, cx, cy);
  });

  /* Appearance picker: rows wear their own theme, so each one is a preview */
  const lookBtn = d.querySelector('[data-looks-open]'), looks = d.getElementById('hh-looks');
  if (lookBtn && looks) {
    const rows = [...looks.querySelectorAll('.hh-looks-row')];
    const setOpen = open => {
      looks.hidden = !open; lookBtn.setAttribute('aria-expanded', String(open));
      if (open) (rows.find(r => r.dataset.pick === HH.themeId()) || rows[0]).focus();
    };
    lookBtn.addEventListener('click', () => setOpen(looks.hidden));
    looks.querySelector('[data-looks-close]').addEventListener('click', () => { setOpen(false); lookBtn.focus(); });
    looks.addEventListener('keydown', e => {
      const i = rows.indexOf(d.activeElement);
      const k = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
      if (k && i > -1) { e.preventDefault(); rows[(i + k + rows.length) % rows.length].focus(); }
      if (e.key === 'Escape') { setOpen(false); lookBtn.focus(); }
    });
    d.addEventListener('pointerdown', e => { if (!looks.hidden && !looks.contains(e.target) && !lookBtn.contains(e.target)) setOpen(false); });
  }

  /* Goat eyes look at the pointer */
  const eyes = [...d.querySelectorAll('[data-eye]')];
  if (eyes.length && fine && !reduce) {
    let raf = 0, px = 0, py = 0;
    addEventListener('pointermove', e => {
      px = e.clientX; py = e.clientY;
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        eyes.forEach(el => {
          const [cx, cy] = centre(el), dx = px - cx, dy = py - cy, m = Math.hypot(dx, dy) || 1;
          el.style.setProperty('--px', (dx / m * 3).toFixed(1) + 'px');
          el.style.setProperty('--py', (dy / m * 1.5).toFixed(1) + 'px');
        });
      });
    }, { passive: true });
  }

  /* Toast */
  let toastEl, toastT;
  HH.toast = msg => {
    if (!toastEl) { toastEl = d.createElement('div'); toastEl.className = 'hh-toast'; toastEl.setAttribute('role', 'status'); d.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-on'), 1800);
  };

  /* Sparks: pixel squares */
  HH.sparks = (x, y, color, n) => {
    if (reduce) return;
    n = n || 14;
    for (let i = 0; i < n; i++) {
      const s = d.createElement('i');
      s.className = 'hh-spark';
      if (color) s.style.setProperty('--c', color);
      s.style.left = x + 'px'; s.style.top = y + 'px';
      d.body.appendChild(s);
      const a = Math.random() * Math.PI * 2, v = 40 + Math.random() * 80;
      s.animate([
        { transform: 'translate(-50%,-50%)', opacity: 1 },
        { transform: `translate(calc(-50% + ${Math.cos(a) * v}px), calc(-50% + ${Math.sin(a) * v + 30}px))`, opacity: 0 }
      ], { duration: 450 + Math.random() * 300, easing: 'steps(8, end)' }).onfinish = () => s.remove();
    }
  };
  d.addEventListener('click', e => {
    const b = e.target.closest('.hh-btn-primary,[data-spark]');
    if (b) HH.sparks(e.clientX || b.getBoundingClientRect().left + 20, e.clientY || b.getBoundingClientRect().top + 20);
  });

  /* Reveal */
  const reveals = d.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(el => io.observe(el));
  } else reveals.forEach(el => el.classList.add('is-in'));

  /* Scramble text */
  HH.scramble = (el, to) => {
    const glyphs = '01<>/\\[]{}=+*#%$&volt';
    const from = el.textContent; to = to || el.dataset.final || from;
    if (reduce) { el.textContent = to; return; }
    let f = 0; const len = Math.max(from.length, to.length), total = 22;
    (function step() {
      let out = '';
      for (let i = 0; i < len; i++) {
        const lock = f / total > i / len;
        out += lock ? (to[i] || '') : (to[i] === ' ' ? ' ' : glyphs[(Math.random() * glyphs.length) | 0]);
      }
      el.textContent = out;
      if (++f <= total) requestAnimationFrame(step); else el.textContent = to;
    })();
  };
  d.querySelectorAll('[data-scramble]').forEach(el => {
    el.dataset.final = el.textContent;
    setTimeout(() => HH.scramble(el), 300);
    el.addEventListener('pointerenter', () => HH.scramble(el));
  });

  /* Header: scrolled state, hide on scroll down, sliding plate + active marker */
  const header = d.querySelector('.hh-header');
  if (header) {
    let last = scrollY;
    const onScroll = () => {
      const y = scrollY;
      header.classList.toggle('is-scrolled', y > 6);
      const menuOpen = header.querySelector('.hh-menu-btn[aria-expanded=true]');
      const looksOpen = looks && !looks.hidden;
      header.classList.toggle('is-hidden', !location.pathname.startsWith('/pages/wiki') && !menuOpen && !looksOpen && y > 240 && y > last + 4 && !header.contains(d.activeElement));
      if (y < last - 4) header.classList.remove('is-hidden');
      last = y;
    };
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
    const nav = header.querySelector('.hh-nav');
    const path = location.pathname.replace(/\/$/, '') || '/';
    const links = nav ? [...nav.querySelectorAll('a')] : [];
    const active = links.find(a => {
      const h = a.getAttribute('href');
      if (!h || h.startsWith('http')) return false;
      return path === h || (h === '/pages/wiki' && path.startsWith('/pages/wiki')) || (h === '/pages/support-hardhoof' && path.startsWith('/cart'));
    });
    if (active) active.setAttribute('aria-current', 'page');
    const pill = nav && nav.querySelector('.hh-nav-pill'), dot = nav && nav.querySelector('.hh-nav-dot');
    const place = (el, show) => {
      if (!pill || !el) return;
      pill.style.width = el.offsetWidth + 'px';
      pill.style.transform = `translateX(${el.offsetLeft}px)`;
      pill.style.opacity = show ? 1 : 0;
    };
    const placeDot = () => { if (dot && active) { dot.style.transform = `translateX(${active.offsetLeft + active.offsetWidth / 2 - 2}px)`; dot.style.opacity = 1; } };
    links.forEach(a => a.addEventListener('pointerenter', () => place(a, true)));
    nav && nav.addEventListener('pointerleave', () => place(active || links[0], false));
    placeDot(); addEventListener('resize', placeDot);
    if (d.fonts) d.fonts.ready.then(placeDot);

    const menuBtn = header.querySelector('.hh-menu-btn'), menu = d.getElementById('hh-mobile');
    if (menuBtn && menu) {
      const setMenu = open => {
        menuBtn.setAttribute('aria-expanded', String(open));
        menu.hidden = !open;
        d.body.style.overflow = open ? 'hidden' : '';
        header.classList.add('is-scrolled');
      };
      menuBtn.addEventListener('click', () => setMenu(menuBtn.getAttribute('aria-expanded') !== 'true'));
      menu.addEventListener('click', e => { if (e.target.closest('a')) setMenu(false); });
      addEventListener('keydown', e => { if (e.key === 'Escape' && !menu.hidden) { setMenu(false); menuBtn.focus(); } });
    }
  }

  /* Command palette: pages, places, and themes */
  const dlg = d.getElementById('hh-cmd');
  if (dlg && dlg.showModal) {
    const input = dlg.querySelector('input'), list = dlg.querySelector('.hh-cmd-list'), peek = dlg.querySelector('.hh-cmd-peek');
    const icons = index.icons || {};
    const themeItems = themes.map(t => ({ t: 'Theme: ' + t.n, theme: t.id, ic: 'eye', d: t.w + ' wallpaper', k: 'theme appearance look colour colors ' + t.id }));
    let items = [], sel = 0;
    const norm = s => (s || '').toLocaleLowerCase();
    const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const hl = HH.highlight;
    function search(q) {
      const words = norm(q).trim().split(/\s+/).filter(Boolean);
      if (!words.length) {
        const recent = HH.store.get('recent', []).map(u => index.pages.find(p => p.u === u)).filter(Boolean).slice(0, 4);
        const out = [];
        if (recent.length) out.push({ sec: 'Recent' }, ...recent.map(p => ({ p })));
        out.push({ sec: 'Go' }, ...index.actions.map(p => ({ p })));
        out.push({ sec: 'Start here' }, ...index.pages.filter(p => p.star).map(p => ({ p })));
        out.push({ sec: 'Themes' }, ...themeItems.map(p => ({ p })));
        return { out, words };
      }
      const scored = [];
      for (const p of index.pages.concat(index.actions, themeItems)) {
        const t = norm(p.t), hay = norm([p.t, p.d, p.g, p.k, (window.HH_BODIES || {})[p.u]].join(' '));
        if (words.every(w => hay.includes(w))) {
          let s = 0;
          words.forEach(w => { if (t.startsWith(w)) s += 10; else if (t.includes(w)) s += 6; else s += 1; });
          scored.push({ p, s });
        }
        (p.h || []).forEach(([ht, slug]) => {
          const hh = norm(ht + ' ' + p.t);
          if (words.every(w => hh.includes(w)) && words.some(w => norm(ht).includes(w))) scored.push({ p, h: [ht, slug], s: 3 + (norm(ht).startsWith(words[0]) ? 3 : 0) });
        });
      }
      scored.sort((a, b) => b.s - a.s);
      return { out: scored.slice(0, 14), words };
    }
    function render() {
      const { out, words } = search(input.value);
      items = [];
      list.innerHTML = out.map(r => {
        if (r.sec) return `<li class="hh-cmd-sec" role="presentation">${esc(r.sec)}</li>`;
        const p = r.p, i = items.length;
        items.push(r);
        const title = r.h ? hl(r.h[0], words) : hl(p.t, words);
        const sub = r.h ? esc(p.t) : hl(p.d || p.g || '', words);
        const ico = p.theme
          ? `<span class="hh-cmd-ico is-theme" data-theme="${p.theme}"><span class="hh-eye" style="--c:var(--accent)"></span></span>`
          : `<span class="hh-cmd-ico">${icons[r.h ? 'hash' : (p.ic || 'doc')] || ''}</span>`;
        return `<li class="hh-cmd-item" role="option" id="hh-opt-${i}" data-i="${i}" data-tone="${p.tone || 'start'}" aria-selected="false">
          ${ico}<span class="hh-cmd-txt"><b>${title}</b><small>${sub}</small></span>
          <span class="hh-cmd-go">${p.x ? '↗' : '↵'}</span></li>`;
      }).join('') || `<li class="hh-cmd-empty">No match. Try “power”, “volt” or “synth”.</li>`;
      sel = 0; mark();
    }
    function mark() {
      list.querySelectorAll('.hh-cmd-item').forEach(li => li.setAttribute('aria-selected', String(+li.dataset.i === sel)));
      const cur = list.querySelector(`[data-i="${sel}"]`);
      if (cur) { cur.scrollIntoView({ block: 'nearest' }); input.setAttribute('aria-activedescendant', cur.id); }
      else input.removeAttribute('aria-activedescendant');
      const r = items[sel];
      if (!peek) return;
      if (!r) { peek.innerHTML = ''; return; }
      const p = r.p, shot = p.s && HH.shots[p.s];
      peek.dataset.tone = p.tone || 'start';
      if (p.theme) { peek.innerHTML = `<figure data-theme="${p.theme}" style="background:var(--desktop)"><span class="hh-eye" style="--c:var(--accent);width:60px;height:34px;border-radius:17px"></span></figure><h4>${esc(p.t.replace('Theme: ', ''))}</h4><p>Wear the site in the ${esc(p.t.replace('Theme: ', ''))} theme, like the Terminal.</p>`; return; }
      peek.innerHTML = `<figure>${shot ? `<img src="${shot}" alt="">` : (icons[p.ic || 'doc'] || '')}</figure><h4>${esc(r.h ? r.h[0] : p.t)}</h4><p>${esc(p.d || '')}</p>`;
    }
    function go(r, newTab) {
      if (!r) return;
      if (r.p.theme) { dlg.close(); HH.setTheme(r.p.theme); return; }
      const url = r.p.u + (r.h ? '#' + r.h[1] : '');
      if (r.p.x || newTab) window.open(url, '_blank', 'noopener'); else location.href = url;
      dlg.close();
    }
    HH.openCmd = q => { input.value = q || ''; render(); dlg.showModal(); input.focus(); input.select(); };
    input.addEventListener('input', render);
    input.addEventListener('keydown', e => {
      if (e.key === 'ArrowDown') { e.preventDefault(); sel = Math.min(items.length - 1, sel + 1); mark(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); sel = Math.max(0, sel - 1); mark(); }
      else if (e.key === 'Enter') { e.preventDefault(); go(items[sel], e.metaKey || e.ctrlKey); }
    });
    list.addEventListener('pointermove', e => { const li = e.target.closest('.hh-cmd-item'); if (li && +li.dataset.i !== sel) { sel = +li.dataset.i; mark(); } });
    list.addEventListener('click', e => { const li = e.target.closest('.hh-cmd-item'); if (li) go(items[+li.dataset.i], e.metaKey || e.ctrlKey); });
    dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
    const closeSearch = dlg.querySelector('[data-cmd-close]');
    if (closeSearch) closeSearch.addEventListener('click', () => dlg.close());
    d.querySelectorAll('[data-cmd-open]').forEach(b => b.addEventListener('click', () => HH.openCmd('')));
    addEventListener('keydown', e => {
      const typing = /INPUT|TEXTAREA|SELECT/.test((e.target.tagName || '')) || e.target.isContentEditable;
      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); dlg.open ? dlg.close() : HH.openCmd(''); }
      else if (e.key === '/' && !typing && !dlg.open) { e.preventDefault(); HH.openCmd(''); }
    });
    const mac = /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);
    d.querySelectorAll('[data-mod-key]').forEach(k => { k.textContent = mac ? '⌘K' : 'Ctrl K'; });
  }

  /* Remember wiki visits for the palette's Recent list */
  if (/^\/pages\/wiki-/.test(location.pathname)) {
    const recent = HH.store.get('recent', []).filter(u => u !== location.pathname);
    recent.unshift(location.pathname);
    HH.store.set('recent', recent.slice(0, 6));
  }
})();

/* Home: the hero Hard Hoof OS terminal, the arc switcher, the machine reel, the mobile dock. */
(function () {
  const d = document, HH = window.HH || {};
  const reduce = !!HH.reduce;
  const CF = 'https://www.curseforge.com/minecraft/mc-mods/hard-hoof';
  const DISCORD = 'https://discord.gg/qkZYC3qakm';

  /* ---------- Terminal ---------- */
  const term = d.querySelector('[data-term]');
  if (term) {
    const log = term.querySelector('.hh-term-log'), body = term.querySelector('.hh-term-body');
    const input = term.querySelector('input'), ghost = term.querySelector('.hh-term-ghost');
    const eye = term.querySelector('.hh-term-tab .hh-eye'), watts = term.querySelector('[data-term-w]'), clock = term.querySelector('[data-term-clock]');
    const PS = 'hoof:/ >';
    const esc = s => String(s).replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]));
    let busy = false, auto = true, history = [], hIdx = 0;
    const print = (html, cls) => { const div = d.createElement('div'); if (cls) div.className = cls; div.innerHTML = html; log.appendChild(div); body.scrollTop = body.scrollHeight; return div; };
    const sleep = ms => new Promise(r => setTimeout(r, reduce ? 0 : ms));
    const echo = cmd => print(`<span class="c-ps">${esc(PS)}</span> ${esc(cmd)}`);
    const devices = [['Ore smelter', 'electric_furnace', '3c9e01d7'], ['Main router', 'item_controller', 'a41f66b2'], ['Assembler', 'assembler', '5ab1e000'], ['Printer', 'matter_printer', '9f3c21aa']];
    const pad = (s, n) => (s + ' '.repeat(n)).slice(0, n);
    const narrow = () => body.clientWidth < 420;
    const nav = (url, label) => { print(`<span class="c-dim">-> opening ${esc(label)}...</span>`); setTimeout(() => { location.href = url; }, reduce ? 0 : 450); };
    const out = (url, label) => { print(`<span class="c-dim">-> ${esc(label)} opens in a new tab</span> <a class="c-link" href="${url}" target="_blank" rel="noopener">${esc(label)} ↗</a>`); window.open(url, '_blank', 'noopener'); };
    const themes = HH.themes || [];
    const swatch = t => `<span class="c-sw" data-theme="${t.id}" style="background:linear-gradient(90deg,var(--desktop) 50%,var(--accent) 50%)"></span>`;
    function wear(id, anchor) {
      const r = (anchor || input).getBoundingClientRect();
      return HH.setTheme && HH.setTheme(id, r.left + 20, r.top + r.height / 2);
    }
    const commands = {
      help() {
        print('<span class="c-head">commands</span>');
        [['dev', 'devices on the bus'], ['storage list', 'what the tanks hold'], ['cat hello.volt', 'read a program'], ['run hello', 'run it'],
         ['theme', 'the themes'], ['theme <name>', 'wear one, here too'], ['printer survey', 'what is around the printer'], ['download', 'get Hard Hoof'],
         ['wiki <topic>', 'search the wiki'], ['roadmap', 'what is left to build'], ['support', 'fund the next machine'], ['discord', 'come say hi'],
         ['dive', 'sound the Tall World'], ['reprogram world', '???'], ['clear', 'clear the screen']]
          .forEach(([c, t]) => print(`  <span class="c-hi">${esc(pad(c, 16))}</span><span class="c-dim">${narrow() ? '' : t}</span>`));
      },
      dev() {
        const a = narrow() ? 12 : 14;
        print(`<span class="c-head">${pad('NAME', a)}${narrow() ? 'KIND' : pad('KIND', 17) + 'ID'}</span>`);
        devices.forEach(([n, k, i]) => print(`${pad(n, a)}<span class="c-hi">${narrow() ? k : pad(k, 17)}</span>${narrow() ? '' : i}`));
      },
      cat(arg) {
        if (!/hello/.test(arg || '')) { print(`<span class="c-warn">cat: ${esc(arg || '?')}: no such file</span> <span class="c-dim">- try: cat hello.volt</span>`); return; }
        HELLO.forEach(l => print(`<span class="c-dim">|</span> ${l}`));
      },
      async run(arg) {
        if (!/^(hello|hello\.volt|\/home\/hello\.volt)?$/.test(arg || '')) { print(`<span class="c-warn">run: ${esc(arg)}: not found</span> <span class="c-dim">- try: run hello</span>`); return; }
        const name = (await ask('Your name? ')).trim() || 'player';
        print(esc('Hello, ' + name + '!'));
      },
      storage(arg) {
        if (arg && !/^list/.test(arg)) { print('<span class="c-dim">in game: storage get, craft, find, list, put</span>'); return; }
        [['cobblestone', 412], ['raw_iron', 96], ['coal', 58], ['raw_copper', 41], ['copper_ingot', 23], ['iron_ingot', 17]]
          .forEach(([n, c]) => print(`${pad(n, 16)}<span class="c-ok">${c}</span>`));
      },
      async printer(arg) {
        if (!/^survey/.test(arg || '')) { print('<span class="c-dim">in game: printer survey, find, mine, fill, save, print</span>'); return; }
        print('<span class="c-dim">surveying 4913 blocks (0.5 kJ)...</span>');
        await sleep(500);
        [['stone', 3902], ['deepslate', 611], ['coal_ore', 41], ['iron_ore', 23], ['copper_ore', 17], ['diamond_ore', 1]]
          .forEach(([n, c]) => print(`${pad(n, 16)}<span class="${n === 'diamond_ore' ? 'c-acc' : 'c-ok'}">${c}</span>`));
        print('<span class="c-dim">next: printer mine iron_ore</span>');
      },
      theme(arg) {
        const want = (arg || '').trim().toLowerCase();
        if (want) {
          const t = themes.find(x => x.id === want || x.n.toLowerCase() === want);
          if (!t) { print(`<span class="c-warn">theme: no theme called ${esc(want)}</span> <span class="c-dim">- type theme</span>`); return; }
          wear(t.id);
          print(`<span class="c-ok">wearing ${esc(t.n)}</span> <span class="c-dim">- the whole site, not just me</span>`);
          return;
        }
        const cur = HH.themeId ? HH.themeId() : 'horn';
        themes.forEach(t => print(`${t.id === cur ? '<span class="c-acc">&gt;</span>' : ' '} ${swatch(t)}<span class="c-hi">${esc(pad(t.n, 11))}</span><span class="c-dim">${narrow() ? '' : esc(pad(t.w, 9))}</span>${esc(t.id)}`));
        print('<span class="c-dim">theme &lt;name&gt; wears one.</span>');
      },
      download() { out(CF, 'CurseForge'); },
      discord() { out(DISCORD, 'Discord'); },
      wiki(arg) { nav('/pages/wiki' + (arg ? '?q=' + encodeURIComponent(arg) : ''), arg ? 'wiki: ' + arg : 'the wiki'); },
      roadmap() { nav('/pages/roadmap', 'the roadmap'); },
      async dive() {
        if (!HH.tallDive) { nav('/pages/wiki-tall-world', 'the Tall World'); return; }
        print('<span class="c-rift">plumb &gt;</span> <span class="c-dim">dropping a line into the Tall World, y 1535 to -1536...</span>');
        await sleep(400);
        HH.tallDive();
      },
      support() { nav('/pages/support-hardhoof', 'support'); },
      ls() { print('<span class="c-hi">wiki/</span>  <span class="c-hi">roadmap/</span>  <span class="c-hi">support/</span>  hello.volt  smelter.volt  router.volt'); },
      whoami() { print('player <span class="c-dim">- research: digital logic (active)</span>'); },
      floppa() { print('<span class="c-hi">Big Floppa</span> <span class="c-dim">is out hunting. Try a savanna, with raw meat.</span>'); },
      clear() { log.innerHTML = ''; },
      sudo() { print('<span class="c-warn">permission denied:</span> reality edits cost energy'); },
      echo(arg) { print(esc(arg || '')); },
      async reprogram(arg) {
        if (!/world|reality|site|page/.test(arg || '')) { print('<span class="c-dim">usage: reprogram world</span>'); return; }
        const cur = HH.themeId ? HH.themeId() : 'horn', pool = themes.filter(t => t.id !== cur);
        const t = pool[(Math.random() * pool.length) | 0];
        if (!t) return;
        print(`<span class="c-rift">bus > zone0</span> <span class="c-dim">write world.theme = ${esc(t.id)}</span>`);
        await sleep(260);
        const wipe = d.createElement('div'); wipe.className = 'hh-wipe'; d.body.appendChild(wipe);
        setTimeout(() => wipe.remove(), 800);
        await sleep(300);
        wear(t.id, term);
        d.querySelectorAll('.hh-hero h1, .hh-brand').forEach(el => { el.classList.remove('hh-glitch'); void el.offsetWidth; el.classList.add('hh-glitch'); });
        const hot = d.querySelector('.hh-hot'); if (hot && HH.scramble) HH.scramble(hot);
        print(`<span class="c-ok">1 region rewritten</span> <span class="c-dim">- cost 4.2 kJ - theme horn puts it back</span>`);
      }
    };
    commands.get = commands.download; commands.install = commands.download; commands.themes = commands.theme;
    const names = ['help', 'dev', 'storage list', 'cat hello.volt', 'run hello', 'theme', 'printer survey', 'download', 'wiki', 'roadmap', 'support', 'discord', 'dive', 'reprogram world', 'clear', 'ls', 'whoami', 'floppa']
      .concat(themes.map(t => 'theme ' + t.id));
    const HELLO = ['<span class="c-hi">let</span> name = input(<span class="c-warn">"Your name? "</span>)', 'print(<span class="c-warn">"Hello, "</span> + name + <span class="c-warn">"!"</span>)'];

    /* The taskbar: a real clock, and a load reading that rises while a program runs */
    const tick = () => { if (clock) { const n = new Date(); clock.textContent = String(n.getHours()).padStart(2, '0') + ':' + String(n.getMinutes()).padStart(2, '0'); } };
    tick(); setInterval(tick, 15000);
    const setBusy = on => {
      busy = on; term.classList.toggle('is-busy', on);
      if (eye) eye.classList.toggle('is-busy', on);
      if (watts) watts.textContent = on ? '2.6' : '1.8';
    };

    /* input() inside a running program: the next Enter answers it */
    let pending = null;
    const ps = term.querySelector('.hh-term-ps');
    function ask(prompt) {
      return new Promise(res => {
        pending = v => { print(esc(prompt) + esc(v)); if (ps) ps.textContent = PS; res(v); };
        if (ps) ps.textContent = prompt.trim();
        if (auto) typeAnswer('Alex');
      });
    }
    async function typeAnswer(v) {
      await sleep(500);
      for (let i = 0; i <= v.length; i++) { if (!auto) return; input.value = v.slice(0, i); await sleep(90); }
      await sleep(250); if (!auto) return; input.value = '';
      if (pending) { const p = pending; pending = null; p(v); }
    }

    async function exec(line) {
      line = line.trim();
      echo(line);
      if (!line) return;
      history.push(line); hIdx = history.length;
      const [cmd, ...rest] = line.split(/\s+/);
      const fn = commands[cmd.toLowerCase()];
      setBusy(true);
      try {
        if (fn) await fn(rest.join(' '));
        else print(`<span class="c-warn">${esc(cmd)}: command not found</span> <span class="c-dim">- type help</span>`);
      } finally { setBusy(false); }
    }
    async function typeLine(text) {
      for (let i = 0; i <= text.length; i++) { if (!auto) return; input.value = text.slice(0, i); await sleep(55 + Math.random() * 40); }
      await sleep(200); if (!auto) return; input.value = '';
      await exec(text);
    }
    async function intro() {
      print('<span class="c-acc">Hard Hoof OS 2.0</span>   <span class="c-dim">help lists commands</span>');
      await sleep(700);
      for (const l of ['dev', 'cat hello.volt', 'run hello']) { if (!auto) return; await typeLine(l); await sleep(500); }
      if (auto) setGhost('theme');
    }
    function setGhost(t) { if (!ghost) return; ghost.textContent = input.value ? '' : t; ghost.style.left = input.offsetLeft + 'px'; }
    const stopAuto = () => { if (auto) { auto = false; input.value = ''; setGhost(''); } };

    /* Tab completion popup, like the in-game shell */
    let ac, acSel = 0, acItems = [];
    const closeAc = () => { if (ac) { ac.remove(); ac = null; } };
    function openAc() {
      const v = input.value.toLowerCase();
      acItems = names.filter(n => n.startsWith(v) && n !== v);
      closeAc();
      if (!acItems.length) return;
      if (acItems.length === 1) { input.value = acItems[0]; return; }
      ac = d.createElement('ul'); ac.className = 'hh-term-ac'; ac.setAttribute('role', 'listbox');
      acSel = 0;
      ac.innerHTML = acItems.slice(0, 9).map((n, i) => `<li role="option" data-i="${i}" aria-selected="${i === 0}">${esc(n)}</li>`).join('');
      ac.style.left = input.offsetLeft + 'px'; ac.style.top = '1.3em';
      input.parentElement.appendChild(ac);
      ac.addEventListener('mousedown', e => { const li = e.target.closest('li'); if (li) { e.preventDefault(); input.value = acItems[+li.dataset.i]; closeAc(); } });
    }
    input.addEventListener('keydown', async e => {
      stopAuto();
      if (ac && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        e.preventDefault(); const n = Math.min(acItems.length, 9); acSel = (acSel + (e.key === 'ArrowDown' ? 1 : n - 1)) % n;
        ac.querySelectorAll('li').forEach((li, i) => li.setAttribute('aria-selected', String(i === acSel))); return;
      }
      if (e.key === 'Tab') { e.preventDefault(); if (ac) { input.value = acItems[acSel]; closeAc(); } else openAc(); return; }
      if (e.key === 'Escape') { closeAc(); return; }
      if (e.key === 'Enter') {
        e.preventDefault();
        if (ac) { input.value = acItems[acSel]; closeAc(); return; }
        if (pending) { const p = pending, v = input.value; pending = null; input.value = ''; p(v); return; }
        if (busy) return;
        const v = input.value; input.value = ''; await exec(v); return;
      }
      if (e.key === 'ArrowUp' && history.length) { e.preventDefault(); hIdx = Math.max(0, hIdx - 1); input.value = history[hIdx]; }
      if (e.key === 'ArrowDown' && history.length) { e.preventDefault(); hIdx = Math.min(history.length, hIdx + 1); input.value = history[hIdx] || ''; }
    });
    input.addEventListener('input', () => { closeAc(); setGhost(''); });
    input.addEventListener('blur', () => setTimeout(closeAc, 100));
    body.addEventListener('click', e => { if (!e.target.closest('a')) { stopAuto(); input.focus({ preventScroll: true }); } });
    term.querySelectorAll('[data-cmd]').forEach(b => b.addEventListener('click', async () => {
      stopAuto(); if (busy) return; await exec(b.dataset.cmd);
    }));
    const start = () => intro();
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => { if (es[0].isIntersecting) { io.disconnect(); start(); } });
      io.observe(term);
    } else start();
  }

  /* ---------- Arc switcher ---------- */
  const arc = d.querySelector('[data-arc]');
  if (arc) {
    const tabs = [...arc.querySelectorAll('.hh-arc-tab')], panels = [...arc.querySelectorAll('.hh-arc-panel')];
    const wire = arc.querySelector('.hh-arc-wire i'), stage = arc.querySelector('.hh-arc-stage');
    const DUR = 6000;
    let cur = -1, timer = 0, playing = false, visible = false;
    function show(i, user) {
      if (i === cur) return;
      cur = i;
      tabs.forEach((t, k) => { t.setAttribute('aria-selected', String(k === i)); t.tabIndex = k === i ? 0 : -1; t.classList.toggle('is-lit', k <= i); t.classList.remove('is-timing'); });
      panels.forEach((p, k) => { p.classList.toggle('is-on', k === i); p.setAttribute('aria-hidden', String(k !== i)); });
      stage.dataset.tone = tabs[i].dataset.tone;
      if (wire) { wire.style.setProperty('--fill', tabs.length > 1 ? (i / (tabs.length - 1) * 100) + '%' : '0'); wire.parentElement.dataset.tone = tabs[i].dataset.tone; }
      if (user) playing = false;
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (!playing || !visible || reduce) return;
      const t = tabs[cur]; void t.offsetWidth; t.classList.add('is-timing'); t.style.setProperty('--dur', DUR + 'ms');
      timer = setTimeout(() => show((cur + 1) % tabs.length), DUR);
    }
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => show(i, true));
      t.addEventListener('keydown', e => {
        const k = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
        if (k) { e.preventDefault(); const n = (i + k + tabs.length) % tabs.length; show(n, true); tabs[n].focus(); }
      });
    });
    playing = false;
    show(0);
    if ('IntersectionObserver' in window) new IntersectionObserver(es => { visible = es[0].isIntersecting; schedule(); }, { threshold: .35 }).observe(arc);
  }

  /* ---------- Machine reel ---------- */
  const reel = d.querySelector('.hh-reel');
  if (reel) {
    const prev = d.querySelector('[data-reel-prev]'), next = d.querySelector('[data-reel-next]'), bar = d.querySelector('.hh-reel-bar i');
    const step = () => (reel.querySelector('.hh-tile') || {}).offsetWidth + 18 || 300;
    const sync = () => {
      const max = reel.scrollWidth - reel.clientWidth;
      if (prev) prev.disabled = reel.scrollLeft < 4;
      if (next) next.disabled = reel.scrollLeft > max - 4;
      if (bar) { const vis = reel.clientWidth / reel.scrollWidth; bar.style.setProperty('--w', vis * 100 + '%'); bar.style.setProperty('--o', (max ? reel.scrollLeft / max : 0) * (1 / vis - 1) * 100 + '%'); }
    };
    prev && prev.addEventListener('click', () => reel.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => reel.scrollBy({ left: step(), behavior: 'smooth' }));
    reel.addEventListener('scroll', sync, { passive: true }); addEventListener('resize', sync); sync();
    /* drag to scroll with a mouse */
    let down = false, sx = 0, sl = 0, moved = 0;
    reel.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = 0; sx = e.clientX; sl = reel.scrollLeft; });
    addEventListener('pointermove', e => {
      if (!down) return;
      const dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx));
      if (moved > 5) { reel.classList.add('is-drag'); reel.scrollLeft = sl - dx; }
    });
    addEventListener('pointerup', () => { if (!down) return; down = false; setTimeout(() => reel.classList.remove('is-drag'), 0); });
    reel.addEventListener('click', e => { if (moved > 5) { e.preventDefault(); moved = 0; } }, true);
  }

  /* ---------- Mobile dock ---------- */
  const dock = d.querySelector('.hh-dock'), heroCta = d.querySelector('.hh-hero-cta'), finalCta = d.querySelector('.hh-final');
  if (dock && heroCta && 'IntersectionObserver' in window) {
    let heroVis = true, finalVis = false;
    const upd = () => dock.classList.toggle('is-on', !heroVis && !finalVis);
    new IntersectionObserver(es => { heroVis = es[0].isIntersecting; upd(); }).observe(heroCta);
    if (finalCta) new IntersectionObserver(es => { finalVis = es[0].isIntersecting; upd(); }).observe(finalCta);
  }
})();

/* Home, October 2026: the next-update filter, the numbers count-up, the species picker (with a pixel mark per
   creature and a Wake me button), the schools of magic and the six axes. Everything is in the HTML already;
   this only chooses what shows. */
(function () {
  const d = document, HH = window.HH || {};
  const reduce = !!HH.reduce;
  const $$ = (root, sel) => [...root.querySelectorAll(sel)];

  /* ---------- Next update: filter by track ---------- */
  const feed = d.querySelector('[data-next]');
  if (feed) {
    const chips = $$(d, '[data-next-track]'), cards = $$(feed, '.hh-next-card');
    chips.forEach(chip => chip.addEventListener('click', () => {
      const want = chip.dataset.nextTrack;
      chips.forEach(c => c.setAttribute('aria-pressed', String(c === chip)));
      cards.forEach(card => { card.hidden = want !== 'all' && card.dataset.track !== want; });
    }));
  }

  /* ---------- Numbers: count up once, when seen ---------- */
  const counts = $$(d, '[data-count]');
  if (counts.length) {
    const run = el => {
      const to = +el.dataset.count;
      if (reduce) return;
      const t0 = performance.now(), dur = 900;
      (function frame(now) {
        const k = Math.min(1, (now - t0) / dur), steps = Math.floor(k * 14) / 14;   // stepped, like everything else here
        el.textContent = Math.round(to * steps).toLocaleString('en-US');
        if (k < 1) requestAnimationFrame(frame); else el.textContent = to.toLocaleString('en-US');
      })(t0);
    };
    if ('IntersectionObserver' in window && !reduce) {
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }), { threshold: .6 });
      counts.forEach(el => io.observe(el));
    }
  }

  /* ---------- A pixel mark per name: 7 x 7, mirrored, seeded by the id ---------- */
  function mark(id) {
    let h = 2166136261;
    for (const ch of id) { h ^= ch.charCodeAt(0); h = Math.imul(h, 16777619); }
    const next = () => { h ^= h << 13; h ^= h >>> 17; h ^= h << 5; return (h >>> 0) / 4294967296; };
    for (let i = 0; i < 4; i++) next();
    let rects = '';
    for (let y = 0; y < 7; y++) for (let x = 0; x < 4; x++) {
      const edge = x === 3 ? .78 : .5 + (y === 3 ? .1 : 0);
      if (next() < edge) {
        rects += `<rect x="${x}" y="${y}" width="1" height="1"/>`;
        if (x < 3) rects += `<rect x="${6 - x}" y="${y}" width="1" height="1"/>`;
      }
    }
    // Two eyes, always: they make it a someone.
    rects += '<rect x="1" y="2" width="1" height="1" class="hh-mark-eye"/><rect x="5" y="2" width="1" height="1" class="hh-mark-eye"/>';
    return `<svg viewBox="0 0 7 7" fill="currentColor" aria-hidden="true">${rects}</svg>`;
  }
  d.querySelectorAll('.hh-spec-btn, .hh-spec-panel').forEach(el => {
    const slot = el.querySelector('.hh-mark');
    if (slot) slot.innerHTML = mark(el.dataset.id);
  });

  /* ---------- Species ---------- */
  const spec = d.querySelector('[data-species]');
  if (spec) {
    const btns = $$(spec, '.hh-spec-btn'), panels = $$(spec, '.hh-spec-panel'), homes = $$(spec, '[data-spec-home]');
    const show = (id, quiet) => {
      btns.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.id === id)));
      panels.forEach(p => { p.hidden = p.dataset.id !== id; });
      if (!quiet) { const b = btns.find(x => x.dataset.id === id); if (b && HH.sparks) { const r = b.getBoundingClientRect(); HH.sparks(r.left + r.width / 2, r.top + r.height / 2, null, 6); } }
    };
    btns.forEach(b => b.addEventListener('click', () => show(b.dataset.id)));
    homes.forEach(chip => chip.addEventListener('click', () => {
      const want = chip.dataset.specHome;
      homes.forEach(c => c.setAttribute('aria-pressed', String(c === chip)));
      btns.forEach(b => { b.hidden = want !== 'All' && b.dataset.home !== want; });
      const open = btns.find(b => b.getAttribute('aria-pressed') === 'true' && !b.hidden) || btns.find(b => !b.hidden);
      if (open) show(open.dataset.id, true);
    }));
    const wake = spec.querySelector('[data-wake]');
    let waking = false;
    wake && wake.addEventListener('click', () => {
      if (waking) return;
      const pool = btns.filter(b => !b.hidden), cur = btns.find(b => b.getAttribute('aria-pressed') === 'true');
      const pick = pool.filter(b => b !== cur)[Math.floor(Math.random() * Math.max(1, pool.length - 1))] || pool[0];
      if (!pick) return;
      if (reduce) { show(pick.dataset.id); return; }
      waking = true; let i = 0;
      const order = [...Array(9)].map(() => pool[Math.floor(Math.random() * pool.length)]);
      const tick = () => {
        if (i < order.length) { show(order[i++].dataset.id, true); setTimeout(tick, 60 + i * 14); }
        else { show(pick.dataset.id); waking = false; }
      };
      tick();
    });
  }

  /* ---------- Schools of magic ---------- */
  const magic = d.querySelector('[data-magic]');
  if (magic) {
    const btns = $$(magic, '.hh-school-btn'), panels = $$(magic, '.hh-school-panel');
    btns.forEach(b => b.addEventListener('click', () => {
      btns.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      panels.forEach(p => { p.hidden = p.dataset.id !== b.dataset.id; });
    }));
  }

  /* ---------- Six axes: pick a lean ---------- */
  const axes = d.querySelector('[data-axes]');
  if (axes) {
    const read = axes.querySelector('[data-axes-read]'), idle = read.textContent;
    const boxes = $$(axes, '.hh-axis');
    const update = () => {
      const on = $$(axes, 'button[aria-pressed=true]').map(b => b.textContent);
      read.textContent = on.length
        ? 'A spell that leans ' + on.join(' and ') + ': what you cannot yet hold kicks back. Backlash never kills.'
        : idle;
    };
    boxes.forEach(box => {
      const two = $$(box, 'button');
      two.forEach(b => b.addEventListener('click', () => {
        const was = b.getAttribute('aria-pressed') === 'true';
        two.forEach(x => x.setAttribute('aria-pressed', 'false'));
        if (!was) b.setAttribute('aria-pressed', 'true');
        update();
      }));
    });
  }
})();

/* Wiki index: live filter with FLIP motion, sliding topic pill, keyboard nav, hover screenshots. */
(function () {
  const d = document, HH = window.HH || {};
  const filter = d.querySelector('#hh-filter');
  if (!filter) return;
  const reduce = !!HH.reduce;
  const cards = [...d.querySelectorAll('.hh-card[data-hh-search]')];
  const chips = [...d.querySelectorAll('[data-hh-topic]')];
  const pill = d.querySelector('.hh-chip-pill');
  const empty = d.querySelector('.hh-empty'), count = d.querySelector('#hh-search-count');
  const clearFilters = d.querySelector('#hh-clear-filters');
  const orig = new Map(cards.map(c => [c, { h: c.querySelector('h2').textContent, p: c.querySelector('p') ? c.querySelector('p').textContent : '' }]));
  let topic = 'All', kb = -1;
  const esc = s => s.replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]));
  const mark = HH.highlight || ((s) => esc(s));
  const placePill = () => {
    const on = chips.find(c => c.dataset.hhTopic === topic);
    if (!pill || !on) return;
    pill.style.width = on.offsetWidth + 'px';
    pill.style.transform = `translate(${on.offsetLeft}px, ${on.offsetTop}px)`;
    pill.style.setProperty('--tone', getComputedStyle(on).getPropertyValue('--tone'));
  };
  function readLocation() {
    const params = new URLSearchParams(location.search);
    filter.value = params.get('q') || '';
    const t = params.get('topic');
    topic = chips.some(c => c.dataset.hhTopic === t) ? t : 'All';
  }
  function apply(updateLocation) {
    const words = filter.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
    const first = new Map(cards.map(c => [c, c.getBoundingClientRect()]));
    let n = 0;
    for (const c of cards) {
      const show = (topic === 'All' || c.dataset.hhGroup === topic) && words.every(w => c.dataset.hhSearch.toLocaleLowerCase().includes(w));
      const was = !c.hidden;
      c.hidden = !show;
      if (show) {
        n++;
        const o = orig.get(c);
        c.querySelector('h2').innerHTML = mark(o.h, words);
        const p = c.querySelector('p'); if (p) p.innerHTML = mark(o.p, words);
        if (!was && !reduce) c.animate([{ opacity: 0, transform: 'scale(.94)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: 'cubic-bezier(.34,1.56,.64,1)' });
      }
    }
    /* FLIP: slide cards that stayed into their new spots */
    if (!reduce) for (const c of cards) {
      if (c.hidden) continue;
      const a = first.get(c), b = c.getBoundingClientRect();
      if (a.width && (a.left !== b.left || a.top !== b.top)) c.animate([{ transform: `translate(${a.left - b.left}px, ${a.top - b.top}px)` }, { transform: 'none' }], { duration: 480, easing: 'cubic-bezier(.2,.8,.2,1)' });
    }
    chips.forEach(c => c.setAttribute('aria-pressed', String(c.dataset.hhTopic === topic)));
    placePill();
    empty.hidden = n !== 0;
    if (count) count.textContent = n + ' of ' + cards.length + ' guides' + (topic === 'All' ? '' : ' · ' + topic)
      + (filter.value.trim() ? ' · “' + filter.value.trim() + '”' : '');
    if (clearFilters) clearFilters.hidden = !filter.value.trim() && topic === 'All';
    setKb(-1);
    if (updateLocation) {
      const url = new URL(location.href);
      if (filter.value.trim()) url.searchParams.set('q', filter.value.trim()); else url.searchParams.delete('q');
      if (topic !== 'All') url.searchParams.set('topic', topic); else url.searchParams.delete('topic');
      history.replaceState(null, '', url);
    }
  }
  const visible = () => cards.filter(c => !c.hidden);
  function setKb(i) {
    cards.forEach(c => c.classList.remove('is-kb'));
    kb = i;
    const v = visible()[i];
    if (v) { v.classList.add('is-kb'); v.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); }
  }
  const cols = () => { const v = visible(); if (v.length < 2) return 1; const top = v[0].offsetTop; let k = 0; while (k < v.length && v[k].offsetTop === top) k++; return k || 1; };
  filter.addEventListener('input', () => apply(true));
  filter.form && filter.form.addEventListener('submit', e => { e.preventDefault(); const v = visible(); const t = v[Math.max(kb, 0)]; if (t) location.href = t.href; });
  filter.addEventListener('keydown', e => {
    const v = visible(); if (!v.length) return;
    const step = { ArrowDown: cols(), ArrowUp: -cols() }[e.key];
    if (step) { e.preventDefault(); setKb(Math.max(0, Math.min(v.length - 1, (kb < 0 ? -1 : kb) + (kb < 0 ? 1 : step)))); }
    else if (e.key === 'Escape') { if (filter.value) { filter.value = ''; apply(true); } else filter.blur(); }
  });
  chips.forEach(c => c.addEventListener('click', () => { topic = c.dataset.hhTopic; apply(true); }));
  const resetFilters = () => { filter.value = ''; topic = 'All'; apply(true); filter.focus(); };
  [d.querySelector('#hh-reset'), clearFilters].filter(Boolean).forEach(b => b.addEventListener('click', resetFilters));
  addEventListener('popstate', () => { readLocation(); apply(false); });
  addEventListener('resize', placePill);
  readLocation(); apply(false);
  if (d.fonts) d.fonts.ready.then(placePill);

  /* Hover preview: real screenshot follows the pointer */
  const shots = HH.shots || {};
  if (matchMedia('(pointer: fine)').matches && Object.keys(shots).length) {
    const peek = d.createElement('div'); peek.className = 'hh-peek'; peek.innerHTML = '<img alt="">';
    d.body.appendChild(peek);
    const img = peek.querySelector('img');
    let on = null, raf = 0, px = 0, py = 0;
    const move = () => { raf = 0; const x = Math.min(innerWidth - 320, px + 24), y = Math.min(innerHeight - 245, py + 24); peek.style.left = x + 'px'; peek.style.top = y + 'px'; };
    d.addEventListener('pointermove', e => {
      const c = e.target.closest && e.target.closest('.hh-card[data-shot]');
      px = e.clientX; py = e.clientY;
      if (c !== on) {
        on = c;
        if (c && shots[c.dataset.shot]) { img.src = shots[c.dataset.shot]; peek.classList.add('is-on'); } else peek.classList.remove('is-on');
      }
      if (on && !raf) raf = requestAnimationFrame(move);
    }, { passive: true });
    addEventListener('scroll', () => { on = null; peek.classList.remove('is-on'); }, { passive: true });
  }
})();

/* Wiki article: progress wire, TOC scrollspy, heading links, recipe grids, copy buttons, prev/next. */
(function () {
  const d = document, HH = window.HH || {};
  const prose = d.querySelector('.hh-doc .hh-prose');
  if (!prose) return;
  const reduce = !!HH.reduce;

  /* Reading progress */
  const bar = d.querySelector('.hh-progress');
  if (bar) {
    let raf = 0;
    const upd = () => {
      raf = 0;
      const r = prose.getBoundingClientRect(), total = r.height - innerHeight * .6;
      bar.style.setProperty('--p', Math.max(0, Math.min(1, (-r.top + 120) / Math.max(1, total))));
    };
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true }); upd();
  }

  /* Heading links + TOC */
  const heads = [...prose.querySelectorAll('h2[id],h3[id]')].filter(h => !h.closest('.hh-related'));
  heads.forEach(h => {
    const b = d.createElement('button');
    b.className = 'hh-anchor'; b.type = 'button'; b.textContent = '#'; b.setAttribute('aria-label', 'Copy link to ' + h.textContent);
    b.addEventListener('click', () => {
      const url = location.origin + location.pathname + '#' + h.id;
      history.replaceState(null, '', '#' + h.id);
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(() => HH.toast && HH.toast('Link copied'), () => HH.toast && HH.toast('Link selected in the address bar. Copy it from there.'));
    });
    h.prepend(b);
  });
  const toc = d.querySelector('.hh-toc');
  if (toc) {
    const contents = toc.closest('details'), desktop = matchMedia('(min-width: 1001px)');
    if (contents) {
      contents.open = desktop.matches;
      desktop.addEventListener('change', e => { contents.open = e.matches; });
    }
  }
  const h2s = heads.filter(h => h.tagName === 'H2');
  if (toc && h2s.length > 1) {
    const links = [...toc.querySelectorAll('a')];
    let cur = -1;
    const setOn = i => {
      if (i === cur) return; cur = i;
      links.forEach((a, k) => {
        a.classList.toggle('is-on', k === i);
        if (k === i) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
      });
    };
    const spy = () => {
      let i = -1;
      h2s.forEach((h, k) => { if (h.getBoundingClientRect().top < innerHeight * .35) i = k; });
      setOn(i < 0 ? 0 : i);
    };
    addEventListener('scroll', spy, { passive: true }); spy();
  } else if (toc && !h2s.length) toc.closest('details').hidden = true;

  /* Tables scroll inside a rounded frame on narrow screens */
  prose.querySelectorAll('table').forEach(tb => {
    if (tb.closest('.hh-related')) return;
    const w = d.createElement('div'); w.className = 'hh-table'; w.tabIndex = 0;
    w.setAttribute('role', 'region'); w.setAttribute('aria-label', 'Scrollable reference table');
    tb.querySelectorAll('thead th').forEach(th => th.setAttribute('scope', 'col'));
    tb.before(w); w.appendChild(tb);
  });

  /* Recipe grids: a pre block of single-letter rows followed by a Key table */
  prose.querySelectorAll('pre > code').forEach(code => {
    const rows = code.textContent.trim().split('\n').map(l => l.trim().split(/\s+/));
    if (rows.length < 1 || rows.length > 5 || !rows.every(r => r.length === rows[0].length && r.length <= 5 && r.every(c => /^[A-Z_]$/.test(c)))) return;
    const pre = code.parentElement;
    let table = pre.nextElementSibling;
    while (table && /^P$/.test(table.tagName)) table = table.nextElementSibling;
    if (table && table.classList.contains('hh-table')) table = table.querySelector('table');
    const names = {};
    const keyRows = new Map();
    if (table && table.tagName === 'TABLE' && /key/i.test(table.querySelector('th') ? table.querySelector('th').textContent : '')) {
      table.querySelectorAll('tbody tr').forEach(tr => {
        const k = tr.cells[0] && tr.cells[0].textContent.trim();
        if (k && k.length === 1) { names[k] = tr.cells[1] ? tr.cells[1].textContent.trim() : k; keyRows.set(k, tr); tr.dataset.key = k; }
      });
    }
    const wrap = d.createElement('div'); wrap.className = 'hh-recipe';
    const grid = d.createElement('div'); grid.className = 'hh-recipe-grid'; grid.style.setProperty('--cols', rows[0].length);
    grid.setAttribute('role', 'img');
    grid.setAttribute('aria-label', 'Recipe pattern: ' + rows.map(r => r.join(' ')).join(' / '));
    rows.flat().forEach(c => {
      const s = d.createElement('span'); s.className = 'hh-slot' + (c === '_' ? ' is-empty' : '');
      s.textContent = c === '_' ? '' : c;
      if (c !== '_') { s.dataset.key = c; if (names[c]) s.dataset.name = names[c]; }
      grid.appendChild(s);
    });
    wrap.appendChild(grid);
    const note = d.createElement('span'); note.className = 'hh-recipe-note'; note.textContent = Object.keys(names).length ? 'Hover a slot or a key row' : '';
    wrap.appendChild(note);
    pre.classList.add('hh-recipe-src'); pre.before(wrap);
    const slots = [...grid.querySelectorAll('.hh-slot[data-key]')];
    const hot = k => {
      slots.forEach(s => { s.classList.toggle('is-hot', s.dataset.key === k); s.classList.toggle('is-dim', !!k && s.dataset.key !== k); });
      keyRows.forEach((tr, key) => tr.classList.toggle('is-hot', key === k));
    };
    grid.addEventListener('pointerover', e => { const s = e.target.closest('.hh-slot[data-key]'); hot(s ? s.dataset.key : null); });
    grid.addEventListener('pointerleave', () => hot(null));
    keyRows.forEach((tr, k) => { tr.addEventListener('pointerenter', () => hot(k)); tr.addEventListener('pointerleave', () => hot(null)); });
    if (!reduce) slots.forEach((s, i) => s.animate([{ opacity: 0, transform: 'scale(.6)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: i * 35, easing: 'cubic-bezier(.34,1.56,.64,1)', fill: 'backwards' }));
  });

  /* Copy buttons on remaining code blocks */
  prose.querySelectorAll('pre:not(.hh-recipe-src)').forEach(pre => {
    const source = pre.querySelector('code') ? pre.querySelector('code').textContent : pre.textContent;
    const b = d.createElement('button'); b.type = 'button'; b.className = 'hh-copy'; b.textContent = 'copy';
    b.setAttribute('aria-label', 'Copy code');
    b.addEventListener('click', () => {
      (navigator.clipboard ? navigator.clipboard.writeText(source.trim()) : Promise.reject()).then(() => { b.textContent = 'copied'; setTimeout(() => { b.textContent = 'copy'; }, 1400); }, () => HH.toast && HH.toast('Copy unavailable. Select the code and copy it manually.'));
    });
    pre.appendChild(b);
  });

  /* Prev / next in catalog order */
  const foot = d.querySelector('.hh-doc-foot');
  const allPages = (HH.index && HH.index.pages) || [];
  const current = allPages.find(p => p.u === location.pathname.replace(/\/$/, ''));
  const pages = current ? allPages.filter(p => p.g === current.g) : [];
  const i = pages.findIndex(p => p.u === location.pathname.replace(/\/$/, ''));
  if (foot && i >= 0) {
    const esc = s => s.replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]));
    const link = (p, label) => p ? `<a href="${p.u}" data-tone="${p.tone}"><small>${label}</small><b>${esc(p.t)}</b></a>` : '<span></span>';
    foot.innerHTML = link(pages[i - 1], '← Previous in ' + current.g) + link(pages[i + 1], 'Next in ' + current.g + ' →');
  }
})();

/* Support: the Battery Bank screen. Pick an amount, watch the cells charge, one button to checkout. */
(function () {
  const d = document, HH = window.HH || {};
  const give = d.querySelector('[data-give]');
  if (!give) return;
  const cells = [...give.querySelectorAll('.hh-give-cell')];
  const go = give.querySelector('[data-give-go]'), label = go && go.querySelector('[data-give-amt]');
  const big = give.querySelector('[data-give-big]'), state = give.querySelector('[data-bank-state]');
  const bars = [...give.querySelectorAll('.hh-battery i')];
  if (!cells.length || !go) return;
  function pick(i, user) {
    cells.forEach((c, k) => { c.setAttribute('aria-checked', String(k === i)); c.tabIndex = k === i ? 0 : -1; });
    const c = cells[i];
    go.href = c.getAttribute('href');
    if (label) label.textContent = c.dataset.amount;
    if (big) big.textContent = c.dataset.amount;
    const lit = Math.round(((i + 1) / cells.length) * bars.length);
    bars.forEach((b, k) => b.classList.toggle('is-on', k < lit));
    const full = i === cells.length - 1;
    give.classList.toggle('is-full', full);
    if (state) state.lastChild.textContent = full ? 'Full' : 'Charging';
    if (user && HH.sparks) { const r = c.getBoundingClientRect(); HH.sparks(r.left + r.width / 2, r.top + r.height / 2, 'var(--success)', 10); }
  }
  cells.forEach((c, i) => {
    c.addEventListener('click', e => { e.preventDefault(); pick(i, true); });
    c.addEventListener('keydown', e => {
      const k = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (k) { e.preventDefault(); const n = (i + k + cells.length) % cells.length; pick(n, true); cells[n].focus(); }
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pick(i, true); }
    });
  });
  give.setAttribute('data-ready', '');
  pick(Math.min(1, cells.length - 1), false);
})();


/* Roadmap: wire fills as you scroll, nodes light, cards open with motion, a filter by state, deep links. */
(function () {
  const d = document, HH = window.HH || {};
  const track = d.querySelector('.hh-rm-track');
  if (!track) return;
  const reduce = !!HH.reduce;
  const items = [...track.querySelectorAll('.hh-rm-list > li:not(.hh-rm-group)')];
  const groups = [...track.querySelectorAll('.hh-rm-list > li.hh-rm-group')];
  const cards = items.map(li => li.querySelector('.hh-rm-card'));
  const wire = track.querySelector('.hh-rm-wire'), fill = wire && wire.querySelector('i');
  const tail = track.querySelector('.hh-rm-tail');
  const count = d.querySelector('#hh-rm-progress'), expand = d.querySelector('#hh-rm-expand');
  if (count) count.textContent = cards.length + ' ' + (count.dataset.suffix || 'left');
  /* Filter by state: the pill slides to the pressed button in steps; tracks with nothing left hide. */
  const filter = d.querySelector('.hh-rm-filter'), buttons = filter ? [...filter.querySelectorAll('button')] : [];
  const pill = filter && filter.querySelector('.hh-rm-filter-pill');
  buttons.forEach(b => {
    const st = b.dataset.rmState, n = st === 'all' ? items.length : items.filter(li => li.dataset.hhState === st).length;
    b.querySelector('small').textContent = n;
    if (!n) b.hidden = true;
  });
  function slide(b) {
    if (!pill || !b) return;
    pill.style.width = b.offsetWidth + 'px';
    pill.style.transform = 'translate(' + b.offsetLeft + 'px,' + b.offsetTop + 'px)';
    pill.style.height = b.offsetHeight + 'px';
  }
  function show(st) {
    buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.rmState === st)));
    items.forEach(li => { li.hidden = st !== 'all' && li.dataset.hhState !== st; });
    groups.forEach(g => {
      const n = items.filter(li => !li.hidden && li.dataset.track === g.dataset.track).length;
      g.hidden = !n; g.querySelector('span').textContent = n;
    });
    slide(buttons.find(b => b.dataset.rmState === st));
    spy();
  }
  buttons.forEach(b => b.addEventListener('click', () => show(b.dataset.rmState)));
  addEventListener('resize', () => slide(buttons.find(b => b.getAttribute('aria-pressed') === 'true')));
  let raf = 0;
  function spy() {
    raf = 0;
    if (!wire) return;
    const w = wire.getBoundingClientRect(), mid = innerHeight * .55;
    const p = Math.max(0, Math.min(1, (mid - w.top) / Math.max(1, w.height)));
    fill.style.setProperty('--fill', p * 100 + '%');
    items.concat(groups).forEach(li => li.classList.toggle('is-lit', li.getBoundingClientRect().top + 36 < mid));
    if (tail) tail.classList.toggle('is-lit', tail.getBoundingClientRect().top < mid);
  }
  addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(spy); }, { passive: true });
  addEventListener('resize', spy); spy(); slide(buttons[0]);
  /* Animate open/close height */
  cards.forEach(card => {
    const sum = card.querySelector('summary'), body = card.querySelector('.hh-rm-body');
    sum.addEventListener('click', e => {
      if (reduce || !body.animate) return;
      e.preventDefault();
      if (card.open) {
        const h = body.offsetHeight;
        body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 280, easing: 'cubic-bezier(.2,.8,.2,1)' }).onfinish = () => { card.open = false; spy(); };
      } else {
        card.open = true;
        const h = body.offsetHeight;
        body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.34,1.56,.64,1)' }).onfinish = spy;
        history.replaceState(null, '', '#' + card.id);
      }
    });
  });
  if (expand) expand.addEventListener('click', () => {
    const open = expand.getAttribute('aria-expanded') !== 'true';
    cards.forEach(c => { c.open = open; });
    expand.setAttribute('aria-expanded', String(open));
    expand.querySelector('span').textContent = open ? expand.dataset.labelClose : expand.dataset.labelOpen;
    spy();
  });
  function focusHash() {
    const target = d.getElementById(location.hash.slice(1));
    if (!target || !target.classList.contains('hh-rm-card')) return;
    if (target.parentElement.hidden) show('all');
    target.open = true;
    target.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
  }
  addEventListener('hashchange', focusHash);
  focusHash();
})();
